import { Container, Label } from '@playcanvas/pcui';

import { Events } from '../events';
import { localize } from './localization';

// Framing aids over the viewport in Render mode: rule-of-thirds guides and the viewport's
// render resolution. workspace.scss hides it outside Render mode.
class RenderOverlay extends Container {
    constructor(events: Events, canvas: HTMLCanvasElement, args = {}) {
        args = {
            ...args,
            id: 'render-overlay'
        };

        super(args);

        ['render-guide-v1', 'render-guide-v2', 'render-guide-h1', 'render-guide-h2'].forEach((name) => {
            const line = document.createElement('div');
            line.className = `render-guide ${name}`;
            this.dom.appendChild(line);
        });

        const badge = new Container({
            id: 'render-overlay-badge'
        });

        badge.append(new Label({
            id: 'render-overlay-caption',
            text: localize('render-overlay.resolution')
        }));

        const resolution = new Label({
            id: 'render-overlay-resolution',
            text: ''
        });
        badge.append(resolution);

        this.append(badge);

        // The backbuffer size, not the CSS size: the pixels this view actually renders at,
        // device pixel ratio included.
        let width = -1;
        let height = -1;
        events.on('prerender', () => {
            if (canvas.width !== width || canvas.height !== height) {
                width = canvas.width;
                height = canvas.height;
                resolution.text = `${width} × ${height}`;
            }
        });
    }
}

export { RenderOverlay };
